import React, { Component } from 'react'
import { message, Tabs, Upload } from 'antd'
import { connect } from 'dva'
import config from '../../utils/config'
import ProfileResume from './profileResume'
import ProfileConfig from './profileConfig'
const _ = require('underscore')

const TabPane = Tabs.TabPane;

class Profile extends Component {

    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    constructor (props) {
        super(props);

        this.state = {
        	imageUrl: '',
            file: {},
        };
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
    	const user = this.props.app.user;
        if (user.picture) this.setState({ imageUrl: config.externalUrl + 'uploads/users/' + user.picture });
    }


    /**
    * Codifica la imagen al formato Base64
    */
    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }


    /**
    * Validación antes de subir la imagen
    */
    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 5MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }


    /**
    * Visualiza la imagen preview subida
    */
    handlePictureChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});

            if (this.state.file.uid) {
            	_.extend(this.props.app.user, {picture: this.state.file.uid + '.jpg'});
                this.props.dispatch({type: 'user/update', payload: this.props.app.user})
                localStorage.setItem('currentUser', JSON.stringify(this.props.app.user));
            }
        }
    }


  	/**
    * Render del componente
    */
    render () {
	    return (
            <div className="content-wrapper user-profile">
		        <section className="content-header nopadding">
				  	<div className="row">
						<div className="col-md-2 col-xs-12 text-center">
							<div className="g1-avatar">
								<Upload
                                    name="file"
                                    accept="image/*"
                                    showUploadList={true}
                                    action={config.externalUrl + "includes/upload.php"}
                                    beforeUpload={this.beforeUpload.bind(this)}
                                    onChange={this.handlePictureChange.bind(this)}
                                    headers={{
                                        "X-Parse-Application-Id": config.appId
                                    }}
                                    data={{
                                        type: 'user',
                                        custom_name: this.state.file.uid + '.jpg'
                                    }}
                                >
                                    {!this.state.imageUrl && !this.props.app.user.picture
                                    	? <img className="img-circle user-image" alt="User Profile" src="assets/img/noimage.png" style={{width: '100px'}} />
										: <img src={this.state.imageUrl || this.props.app.user.picture} alt="User Profile" className="img-circle user-image" style={{width: '100px', height: '100px'}} />
                                    }
                                </Upload>
							</div>
						</div>
						<div className="col-md-4 nopadding tag-name">
							<h3>{this.props.app.user.name}</h3>
							<small>{this.props.app.user.email}</small><br />
							<small>{this.props.app.user.type}</small>
						</div>
						<div className="col-md-6 col-xs-12">
						</div>
					</div>
				</section>

				<section className="content">
					<div className="row">
						<div className="col-xs-12 col-md-12">
							<Tabs defaultActiveKey="1" type="card">
						    	<TabPane tab="Resumen" key="1">
                                    <ProfileResume />
						    	</TabPane>

							    <TabPane tab="Configuración" key="2">
							    	<ProfileConfig />
							    </TabPane>
						  	</Tabs>
						</div>
					</div>
				</section>
		    </div>
	    )
	}
}

export default connect(({app}) => ({app}))(Profile)


// WEBPACK FOOTER //
// ./src/components/profile/index.js